import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export function PayPalCheckout({ form, formRef }: { form: any; formRef: React.RefObject<HTMLFormElement> }) {
  const { payload, promo, rewards, quote, ship } = useCart();
  const nav = useNavigate();
  const [cfg, setCfg] = useState<any>(null);
  useEffect(() => { api.get("/paypal/config").then((r) => setCfg(r.data)).catch(() => setCfg({ enabled: false })); }, []);
  if (!cfg?.enabled || !quote || quote.total <= 0) return null;

  return (
    <div data-testid="paypal-checkout">
      <div className="flex items-center gap-4 my-2 text-[11px] tracking-[0.2em] uppercase text-neutral-400"><span className="flex-1 h-px bg-neutral-200" />or<span className="flex-1 h-px bg-neutral-200" /></div>
      <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: cfg.currency, intent: "capture" }}>
        <PayPalButtons
          style={{ layout: "horizontal", color: "black", shape: "rect", label: "paypal", height: 50, tagline: false }}
          createOrder={async () => {
            if (formRef.current && !formRef.current.reportValidity()) throw new Error("form-invalid");
            try {
              const r = await api.post("/paypal/create-order", { ...form, ...ship, items: payload(), promo_code: promo || null, rewards: rewards || null });
              return r.data.paypal_order_id;
            } catch (e) { toast.error(errMsg(e)); throw e; }
          }}
          onApprove={async (data) => {
            try {
              await api.post(`/paypal/capture/${data.orderID}`);
              nav(`/payment/success?session_id=${data.orderID}`);
            } catch (e) { toast.error(errMsg(e)); }
          }}
          onError={(e: any) => { if (String(e?.message || e).indexOf("form-invalid") === -1) toast.error("PayPal couldn't complete the payment. Please try again."); }}
        />
      </PayPalScriptProvider>
    </div>
  );
}
